var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#13BF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.0625H6.4485L7.7265 11.8367H10.2735L11.5515 14.0625H9ZM7.7265 6.16275L6.4485 3.9375H11.5515L10.2735 6.16275H7.7265ZM13.3515 11.5284L12.0729 13.7548L10.7994 11.529H10.8L12.0729 9.30263H14.625L13.3515 11.5284ZM4.6485 6.4665L5.9265 4.24069L7.2 6.4665L5.9265 8.69175H3.375L4.6485 6.4665ZM7.19944 11.529H7.2L5.9265 13.7548L4.6485 11.529L3.375 9.30206H5.9265L7.2 11.5279L7.19944 11.529ZM13.3515 6.4665L14.625 8.69231H12.0735L10.7994 6.4665L12.0729 4.24069L13.3515 6.4665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCob);
export default __webpack_public_path__ + "static/media/cob.7e2923cb6c1a2789947086d49556c8b6.svg";
export { ForwardRef as ReactComponent };